if ($('.my-slider').length) {

var slider = tns({
    container: '.my-slider',
    items: 1,
    slideBy: 'page',
    navContainer: ".slider-thumbnail",
    navAsThumbnails: true,
    mouseDrag: true,
    controls: false,
  })
}